class CartRemoveButton extends HTMLElement {
    constructor() {
        super(), this.addEventListener("click", event => {
            event.preventDefault(), (this.closest("cart-items") || this.closest("cart-drawer-items")).updateQuantity(this.dataset.index, 0)
        })
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super(), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
        const debouncedOnChange = debounce(event => {
            this.onChange(event)
        }, ON_CHANGE_DEBOUNCE_TIMER);
        this.addEventListener("change", debouncedOnChange.bind(this))
    }
    cartUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
            event.source !== "cart-items" && this.onCartUpdate()
        })
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
    }
    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"), event.target.dataset.quantityVariantId)
    }
    onCartUpdate() {
        this.tagName === "CART-DRAWER-ITEMS" ? fetch(`${routes.cart_url}?section_id=cart-drawer`).then(response => response.text()).then(responseText => {
            const html = new DOMParser().parseFromString(responseText, "text/html"),
                selectors = ["cart-drawer-items", ".drawer__footer"];
            for (const selector of selectors) {
                const targetElement = document.querySelector(selector),
                    sourceElement = html.querySelector(selector);
                targetElement && sourceElement && targetElement.replaceWith(sourceElement)
            }
            initUUCartAddons()

            updateRelatedProducts();
        }).catch(e => {
            console.error(e)
        }) : fetch(`${routes.cart_url}?section_id=main-cart-items`).then(response => response.text()).then(responseText => {
            const sourceQty = new DOMParser().parseFromString(responseText, "text/html").querySelector("cart-items");
            this.innerHTML = sourceQty.innerHTML
        }).catch(e => {
            console.error(e)
        })
    }
    getSectionsToRender() {
        return [{
            id: "main-cart-items",
            section: document.getElementById("main-cart-items").dataset.id,
            selector: ".js-contents"
        }, {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section"
        }, {
            id: "cart-live-region-text",
            section: "cart-live-region-text",
            selector: ".shopify-section"
        }]
    }
    updateQuantity(line, quantity, name, variantId) {
        this.enableLoading(line);
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map(section => section.section),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body
        }).then(response => response.text()).then(state => {
            const parsedState = JSON.parse(state),
                quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`),
                items = document.querySelectorAll(".cart-item");
            if (parsedState.errors) {
                quantityElement.value = quantityElement.getAttribute("value"), this.updateLiveRegions(line, parsedState.errors);
                return
            }
            this.classList.toggle("is-empty", parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector("cart-drawer"),
                cartFooter = document.querySelector("cart-footer");
            cartFooter && cartFooter.classList.toggle("is-empty", parsedState.item_count === 0), cartDrawerWrapper && cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0), this.getSectionsToRender().forEach(section => {
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
            });
            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : void 0;
            let message = "";
            items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value) && (typeof updatedValue > "u" ? message = window.cartStrings.error : message = window.cartStrings.quantityError.replace("[quantity]", updatedValue)), this.updateLiveRegions(line, message);
            const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            lineItem && lineItem.querySelector(`[name="${name}"]`) ? cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus() : parsedState.item_count === 0 && cartDrawerWrapper ? trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a")) : document.querySelector(".cart-item") && cartDrawerWrapper && trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name")), publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items",
                cartData: parsedState,
                variantId
            })

            updateRelatedProducts();
        }).catch(() => {
            this.querySelectorAll(".loading__spinner").forEach(overlay => overlay.classList.add("hidden"));
            const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
            errors.textContent = window.cartStrings.error
        }).finally(() => {
            this.disableLoading(line), initUUCartAddons()
        })
    }
    updateLiveRegions(line, message) {
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        lineItemError && (lineItemError.querySelector(".cart-item__error-text").innerHTML = message), this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        cartStatus.setAttribute("aria-hidden", !1), setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", !0)
        }, 1e3)
    }
    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML
    }
    enableLoading(line) {
        (document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.add("cart__items--disabled");
        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
            cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
        [...cartItemElements, ...cartDrawerItemElements].forEach(overlay => overlay.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", !1)
    }
    disableLoading(line) {
        (document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.remove("cart__items--disabled");
        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
            cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
        cartItemElements.forEach(overlay => overlay.classList.add("hidden")), cartDrawerItemElements.forEach(overlay => overlay.classList.add("hidden"))
    }
}
customElements.define("cart-items", CartItems), customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", debounce(event => {
            const body = JSON.stringify({
                note: event.target.value
            });
            fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                body
            })
        }, ON_CHANGE_DEBOUNCE_TIMER))
    }
}), document.addEventListener("DOMContentLoaded", function() {
    if (!window.location.pathname.includes("/cart/")) return !1;
    document.querySelectorAll(".product__cross-sell-content-add_to_cart").forEach(function(crossSellButton) {
        crossSellButton.addEventListener("click", async function() {
            const wrapper = this.closest(".product__cross-sell, .product__cross-sell-simple");
            if (!wrapper) return;
            const productId = wrapper.getAttribute("data-id"),
                quantity = 1;
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [{
                            id: productId,
                            quantity
                        }]
                    })
                });
                if (!response.ok) throw new Error("Network response was not ok.");
                const data = await response.json();
                console.log("Product added to cart:", data), location.reload()
            } catch (error) {
                console.error("There was a problem adding the product to the cart:", error)
            }
        })
    })
}), document.addEventListener("DOMContentLoaded", function() {
    if (!(typeof cartItems > "u")) {
        var crossSellProducts = document.querySelectorAll(".product__cross-sell, .product__cross-sell-simple");
        crossSellProducts.forEach(function(crossSellProduct) {
            var productId = crossSellProduct.getAttribute("data-id"),
                inCart = cartItems.some(function(item) {
                    return item.id.toString() === productId
                });
            inCart || (crossSellProduct.style.display = "block")
        })
    }
}), document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".product__cross-sell-content-see_more").forEach(function(button) {
        button.addEventListener("click", function() {
            const seeMoreText = this.nextElementSibling;
            seeMoreText && seeMoreText.classList.contains("product__cross-sell-content-see_more_text") && (seeMoreText.style.display === "block" ? seeMoreText.style.display = "none" : seeMoreText.style.display = "block")
        })
    })
});

function initUUCartAddons() {
    var cross_swiper = new Swiper(".sidecart-swiper", {
        slidesPerView: 1.5,
        spaceBetween: 20,
        breakpoints: {
            401: {
                slidesPerView: 2.2,
                spaceBetween: 20
            }
        }
    });
    setTimeout(function() {
        bindAddToCartButtons();
        initializeShippingProtection();
        initializeCountdowns();
    }, 100)
}
document.addEventListener("DOMContentLoaded", function() {
    initUUCartAddons()
});

function bindAddToCartButtons() {
    document.querySelectorAll(".cross-sell-atc").forEach(function(button) {
        button.addEventListener("click", function(e) {
            e.preventDefault();
            var productId = this.getAttribute("data-product-id");
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    items: [{
                        id: productId,
                        quantity: 1
                    }]
                })
            }).then(response => response.json()).then(data => {
                fetch(`${routes.cart_url}?section_id=cart-drawer`).then(response => response.text()).then(responseText => {
                    const html = new DOMParser().parseFromString(responseText, "text/html"),
                        selectors = ["cart-drawer-items", ".drawer__footer"];
                    for (const selector of selectors) {
                        const targetElement = document.querySelector(selector),
                            sourceElement = html.querySelector(selector);
                        targetElement && sourceElement && targetElement.replaceWith(sourceElement)
                    }
                    initUUCartAddons()
                }).catch(e2 => {
                    console.error(e2)
                })
            }).catch(error => {
                console.error("Error:", error)
            })
        })
    })
}



// Cart expiry countdown
function startCountdown(element) {
    const key = 'cartExpiryCountdown';
    let timer;

    // Check if there's a saved timer in sessionStorage
    const savedTimer = sessionStorage.getItem(key);
    if (savedTimer) {
        timer = parseInt(savedTimer, 10);
    } else {
        timer = parseInt(element.dataset.minutes, 10) * 60;
        sessionStorage.setItem(key, timer.toString());
    }

    function updateDisplay() {
        let minutes = Math.floor(timer / 60);
        let seconds = timer % 60;

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        element.textContent = minutes + ":" + seconds;

        if (timer > 0) {
            timer--;
            sessionStorage.setItem(key, timer.toString());
            setTimeout(updateDisplay, 1000);
        } else {
            element.textContent = "00:00";
            // Reset timer
            // sessionStorage.removeItem(key);
        }
    }

    updateDisplay();
}
document.addEventListener('DOMContentLoaded', initializeCountdowns);
function initializeCountdowns() {
    const countdownElements = document.querySelectorAll('.countdown');
    if (countdownElements.length > 0) {
        countdownElements.forEach(startCountdown);
    }
}

// Shipping protection
document.addEventListener('DOMContentLoaded', initializeShippingProtection);
function initializeShippingProtection() {
    const shippingProtectionToggle = document.getElementById('shipping-protection-toggle');

    if (shippingProtectionToggle) {
        // Remove existing event listener to avoid duplicates
        shippingProtectionToggle.removeEventListener('change', handleShippingProtectionChange);

        // Add event listener
        shippingProtectionToggle.addEventListener('change', handleShippingProtectionChange);
    }
}
function handleShippingProtectionChange() {
    const variantId = this.dataset.variantId;
    const quantity = this.checked ? 1 : 0;
    updateShippingProtection(variantId, quantity, this);
}
function updateShippingProtection(variantId, quantity, toggleElement) {
    // Disable the toggle
    toggleElement.disabled = true;

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const lineItemIndex = cart.items.findIndex(item => item.variant_id.toString() === variantId);
            const cartDrawerItems = document.querySelector('cart-drawer-items');

            if (quantity > 0 && lineItemIndex === -1) {
                // Add item
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: [{ id: variantId, quantity: quantity }]
                    })
                });
            } else if (quantity === 0 && lineItemIndex !== -1) {
                // Remove item
                return fetch(`${routes.cart_change_url}`, {
                    ...fetchConfig(),
                    body: JSON.stringify({
                        line: lineItemIndex + 1,
                        quantity: 0
                    })
                });
            }
        })
        .then(() => {
            // Refresh the cart drawer
            return fetch(`${routes.cart_url}?section_id=cart-drawer`);
        })
        .then(response => response.text())
        .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            const selectors = ["cart-drawer-items", ".drawer__footer"];
            for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                    targetElement.replaceWith(sourceElement);
                }
            }
            initUUCartAddons();
        })
        .catch(error => {
            console.error('Error updating cart:', error);
            toggleElement.checked = !toggleElement.checked; // Revert the toggle state
        })
        .finally(() => {
            // Re-enable the toggle
            toggleElement.disabled = false;
        });
}
